import { GameConfig } from "../hooks/useGameQuestions";
import { PracticeMethods } from "./numbers.utils";

export const SMALL_DOT_SCORE = 0;
export const POWER_PILL_SCORE = 0;

export const getScore = ({
  practiceMethod,
  rows,
  digit1,
  digit2,
  totalCorrect,
}: {
  practiceMethod: PracticeMethods;
  rows: number;
  digit1: number;
  digit2: number;
  totalCorrect: number;
}) => {
  let score = 0;

  if (
    practiceMethod == PracticeMethods.Addition ||
    practiceMethod == PracticeMethods.AdditionSubtraction
  ) {
    // For Addition and AdditionSubtraction
    score = totalCorrect * rows * digit1;
  } else {
    // For Multiplication and Division
    score = totalCorrect * (digit1 + digit2);
  }

  return Math.floor(score);
};

export const getOverallScore = ({
  smallDotsCount,
  powerPillsCount,
  correctAnswersCount,
  gameConfig: gameConfig,
}: {
  smallDotsCount: number;
  powerPillsCount: number;
  correctAnswersCount: number;
  gameConfig: GameConfig;
}) => {
  return (
    smallDotsCount * SMALL_DOT_SCORE +
    powerPillsCount * POWER_PILL_SCORE +
    getScore({
      practiceMethod: gameConfig.practiceMethod,
      rows: gameConfig.rows,
      digit1: gameConfig.digits[0],
      digit2: gameConfig.digits[1],
      totalCorrect: correctAnswersCount,
    })
  );
};
